import { render, staticRenderFns } from "./contributions.vue?vue&type=template&id=6e83fb17"
import script from "./contributions.vue?vue&type=script&lang=js"
export * from "./contributions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports